module.exports = __webpack_public_path__ + "img/sr-merge.71627fc3.png";